<template>
  <div class="banner__layout">
    <div class="banner__banner banner_main">
      <div class="banner__left">
        <h1>{{ $t("HELP_CENTER") }}</h1>
        <p>{{ $t("ABOUT_TEXT") }}</p>
        <ul class="banner__menu">
          <li class="banner__menu-item">
            <a
              href="#"
              class="banner__menu-link"
              @click.prevent="
                managePopupState({ popup: 'projectAboutPopup', _state: true })
              "
              >{{ $t("ABOUT") }}</a
            >
          </li>
          <li class="banner__menu-item">
            <a
              href="#"
              class="banner__menu-link"
              @click.prevent="
                managePopupState({ popup: 'politicsPopup', _state: true })
              "
              >{{ $t("POLITICS") }}</a
            >
          </li>
          <li class="banner__menu-item">
            <a
              href="#"
              class="banner__menu-link"
              @click.prevent="
                managePopupState({ popup: 'contractPopup', _state: true })
              "
              >{{ $t("CONTRACT") }}</a
            >
          </li>
        </ul>
      </div>
      <div class="banner__right">
        <Loader v-if="loading" />
        <ul
          v-else
          class="banner__countries countries"
          v-intro-autostart="true"
          v-intro-autostart.config="{
            doneLabel: 'Ok',
            prevLabel: '←',
            nextLabel: '→',
            skipLabel: '×'
          }"
          v-intro="$t('HINTS.HOME_HINT_STEP_1')"
          v-intro-autostart:on.complete="onComplete"
          v-intro-autostart:on.exit="onComplete"
          v-intro-step="1"
          v-intro-if="hints('home')"
        >
          <li
            v-for="({ name, slug, flag }, index) in countries"
            :key="`${name}_${index}`"
            class="countries__country"
          >
            <a class="countries__country-link" :href="slug">
              <img :src="flag" :alt="$t(name)" />
              <span>{{ $t(slug) }}</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "CommonBanner",
  data: () => ({
    loading: true
  }),
  methods: {
    ...mapMutations(["managePopupState", "manageHints"]),
    ...mapActions(["fetchCountries"]),
    onComplete() {
      this.manageHints({ show: false, hints: "home_hints" });
    }
  },
  computed: {
    ...mapGetters(["countries", "hints"])
  },
  mounted() {
    this.fetchCountries().then(() => (this.loading = false));
  }
};
</script>

<style lang="scss">
@import "@/assets/_vars";

.banner {
  .banner_main,
  .banner_volunteers,
  .banner_serafim {
    display: flex;

    .banner {
      &__menu {
        flex-wrap: wrap;
        margin: 20px 0 0;

        &-item {
          margin: 0 25px 0 0;
        }

        &-link {
          font-weight: $b_fw;
          color: $aux_c;
          white-space: nowrap;
        }
      }

      &__bottom {
        margin: 30px 0 0;
      }

      &__right {
        align-items: center;
        justify-content: center;
      }

      &__countries {
        padding: 20px;
      }

      &__button {
        padding: 7.5px 35px;
      }

      &__right,
      &__menu,
      &__bottom {
        display: flex;
      }

      &__left,
      &__right {
        flex-basis: 50%;
      }
    }
    @media screen and (max-width: $max-md) {
      flex-direction: column;

      & .banner__right {
        margin: 20px 0 0;
      }
    }
  }
}

.countries {
  display: grid;

  &__country {
    margin: 5px;

    &-link {
      display: flex;
      flex-direction: column;
      align-items: center;

      img {
        margin: 0 0 5px;
      }

      span {
        font-weight: $b_fw;
        white-space: nowrap;
        color: $aux_c;
      }
    }
  }

  @media screen and (min-width: $min-sm) {
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 10px;
  }

  @media screen and (max-width: $min-sm - 1) {
    grid-template-columns: repeat(2, 1fr);
  }
}
</style>
